var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-16"},[_c('v-btn',{staticClass:"noCaps",attrs:{"dark":"","x-large":"","rounded":"","color":_vm.wsDARK},on:{"click":_vm.addBlock}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" Додати блок ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }